import React from 'react';
import ComponentContainer from '../../components/component-container/ComponentContainer';
import ProductSign from './ProductSign';
import { Dialog, DialogContent } from '@/components/ui/dialog';

const ProductsAndServices = () => {
	const [open, setOpen] = React.useState(false);
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<ComponentContainer>
			<h1>Productos y Servicios</h1>
			<div className="cyber-spacer medium"></div>
			<p>
				Aquí te mostramos algunos de los productos y servicios que
				CyberSign te ofrece.
			</p>
			<div className="cyber-grid three-columns">
				<div
					className="cyber-card bordered flex direction-column justify-between align-start"
					onClick={() => setOpen(true)}
				>
					<h5>Firma Electrónica</h5>
					<div className="cyber-spacer medium"></div>
					<p>Haz click aqui para tener más información</p>
				</div>
			</div>

			<Dialog open={open} onOpenChange={handleClose}>
				<DialogContent>
					<ProductSign />
				</DialogContent>
			</Dialog>
		</ComponentContainer>
	);
};

export default ProductsAndServices;
